(function ($) {
  'use strict';

  $(document).ready(function() {

    preselectOptionsBasedOnUrl();
    initialize_search();
    initializeCustomDropdowns();

    $('.menu-main-search').click(function() { // We need to initialize the search when the search becomes visible on mobile
      initialize_search();
      $('.custom-dropdown').css('display', 'none'); // Make sure custom dropdowns aren't visible
    });

    if ($('.menu-main-search:visible').length === 1) { // We're on mobile
      $('#mobileSearch .search-type').on('change', function() {
        initialize_search();
      });
    } else {
      // On change applied to the visible select only 
      $('.search-type:visible').on('change', function() {
        initialize_search();
      });
    }

    $('.header__search form').on('submit', function(event) {
      event.preventDefault();

      var $searchMode = ($('.menu-main-search:visible').length > 0) ? 'mobile' : 'desktop';
    

      if ($searchMode == 'desktop') { // We only need to get these values if it's the custom dropdowns for desktop
        var $visibleSearchTypeDropdown = $('.custom-dropdown.search-type-dropdown:visible');
        var $visibleCatalogDropdown = $('.custom-dropdown.dropdown-catalog:visible');
        var $searchTypeDropdown = $('.custom-dropdown.search-type-dropdown:visible');
        var searchType = $searchTypeDropdown.find('.options li').filter(function() {
          return $(this).text() === $searchTypeDropdown.find('.selected-option').text();
        }).data('value');
      } else {
        var searchType = $('.search-type:visible').val();
      }

      // Check if there are dropdowns visible
      if (($searchMode == 'mobile' && $('.search-type:visible').val() == 'search-catalog') || (($searchMode == 'desktop') && ($visibleSearchTypeDropdown.length > 0 || $visibleCatalogDropdown.length > 0) && searchType == 'search-catalog'))  {

        // How to get the values of the fields varies from desktop and mobile. Desktop has some custom stylized dropdown
        if ($searchMode == 'desktop') {
          // Get the data-value of the selected option from search-type-dropdown
          var limit = $visibleCatalogDropdown.find('.options li').filter(function() {
            return $(this).text() === $visibleCatalogDropdown.find('.selected-option').text();
          }).data('value');
        } else {
          var limit = $('.dropdown-catalog:visible').val() ;
        }
    
        // Get the data-value of the selected option from dropdown-catalog
        var searchTerm = $('.header__search .search-field:visible').val();

        // Default logic after retrieving limit and search term
        searchTerm = searchTerm || '*';
        var ctxBranchCode = 1,
            ctxLang = "1033",
            ctxSuffix = "0.0.6",
            ctx = ctxBranchCode + "." + ctxLang + "." + ctxSuffix;
    
        // Conditional logic for limit modification
        if(limit === '_all_'){
            limit = '';
        }
        else if(limit === 'spc'){
            limit = '';
        }
        else if(limit === 'available'){
            limit = 'AVAILABILITY > 0';
        }
        else if(limit === 'stm'){
            limit = "TOM=stm";
        }
        else if(limit === 'stv'){
            limit = "TOM=stv";
        }
        else if(limit === 'fortyone'){
            limit = "41";
        }
        else if(limit === 'eight'){
            limit = "8";
        }
        else if(limit === 'thirteen'){
            limit = "13";
        }
        else if(limit === 'fifteen'){
            limit = "15";
        }
        else if(limit === 'nineteen'){
            limit = "19";
        }
        else if(limit === 'twenty'){
            limit = "20";
        }
        else if(limit === 'twentyseven'){
            limit = "27";
        }
        else if(limit === 'emg'){
            limit = "TOM=emg";
        }else if(limit === 'threefour'){
            limit = "34";
        }else if(limit === 'foursix'){
            limit = "46";
        }else if(limit === 'thirtyfive'){
            limit = "35";
        }
        else if(limit){
            limit = '{list}' + limit + '{/list}';
        }
    
        // Prefix limit with 'MAT=' if necessary
        if((limit != 'AVAILABILITY > 0') && (limit != '8&searchid=25') && (limit != 'TOM=stm') && (limit != 'TOM=stv') && (limit != 'TOM=emg')){
            limit = 'MAT=' + limit;
        }
    
        var params = {
            ctx: ctx,
            type: 'Keyword',
            term: searchTerm,
            by: 'KW',
            sort: 'MP',
            limit: limit,
            page: 0
        };
        
        // URL encoding parameters
        var url = "https://polaris.hclibrary.org/polaris/search/searchresults.aspx?" + $.param(params);
        url = url.replace(/limit=([^&]*)/, 'limit=' + params.limit);
        console.log(url);
    
        // Open the search result in a new tab
        window.open(url, '_blank');
    
      } else {
        // Submit the form if no dropdowns are visible
        $('.search-type').val(searchType);

        // This is only needed if we're in desktop with the custom dropdowns
        if ($searchMode == 'desktop') {
          // Check if event branch is visible to select it's value
          var $eventBranchDropdown = $('.custom-dropdown.dropdown-branches:visible');
          if ($eventBranchDropdown.length == 1) {
            // Get the data-value of the selected option instead of the text
            var eventBranch = $eventBranchDropdown.find('.options li').filter(function() {
              return $(this).text() === $eventBranchDropdown.find('.selected-option').text();
            }).data('value');
          
            // Assign the selected data-value to the input field
            $('select[name="event_branch"]').val(eventBranch);
          }
        } 

        this.submit();
      }
    
    });    

    // If it's desktop, make sure all selects are hidden
    if ($('.menu-main-search:visible').length === 0) {
      console.log('ok, sí, es desktop');
        // Make sure all selects are hidden
        $('.search-bar__filters select').hide();
    }
  });

  function initialize_search() {
    console.log('initialize search');

    // Make sure we're selecting the visible element
    var $visibleSearchType = $('.search-type:visible');

    $('.header__search .search-field').attr('name', 's');

    $('.search-bar__filters').removeClass('search-site');

    console.log('the visible one is ' + $visibleSearchType.val());

    if ($visibleSearchType.val() === 'search-catalog') {

      $('.header__search .search-field').attr('name', 'term');
      $('.dropdown-branches').css('display', 'none');
      $('.dropdown-catalog').css('display', 'flex');

    } else if ($visibleSearchType.val() === 'search-site' || $visibleSearchType.val() === 'search-events') {
      
      if ($visibleSearchType.val() === 'search-site') {
        console.log('show search site');
        $('.dropdown-catalog').css('display', 'none');
        $('.dropdown-branches').css('display', 'none');
        $('.search-bar__filters').addClass('search-site'); // Adding this class to control the visibility of the field
        
      } else {
        $('.dropdown-branches').css('display', 'flex');
        $('.dropdown-catalog').css('display', 'none');
      }

      $('.header__search form').attr('target', '_self');
      
    } else if ($visibleSearchType.val() === 'advanced-search') {
        const advancedSearchUrl = 'https://polaris.hclibrary.org/polaris/search/default.aspx?ctx=1.1033.0.0.3&type=Advanced';
        
        // Check if user is on mobile
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            // Redirect on mobile
            window.location.href = advancedSearchUrl;
        } else {
            // Open in new window on desktop
            window.open(advancedSearchUrl, '_blank');
        }
        
        $('.search-type:visible').val('search-catalog'); // Change back to search catalog
    }

    if ($('.menu-main-search:visible').length) { // If it's the mobile search, don't show any custom dropdown, make sure they're hidden
      $('.custom-dropdown').css('display', 'none'); 

      // Make sure the mobile search fields are visible
      $('.search-type').show();

    }
  }

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function preselectOptionsBasedOnUrl() {
      var searchType = getParameterByName('search-type');
      var catalogCategory = getParameterByName('catalog_category');
      var eventBranch = getParameterByName('event_branch');
      
      var searchQuery = getParameterByName('s');
      $('.search-field:visible').val(searchQuery);

      // If there are custom dropdowns, apply the logic to set the values
      if ($('.custom-dropdown:visible').length > 0) {

        // Preselect the searchType dropdown
        if (searchType && $('.search-type-dropdown').length) {
          $('.search-type-dropdown .options li').each(function() {
            if ($(this).data('value') === searchType) {
              // Set the selected option text and the data-value
              $('.search-type-dropdown .selected-option').text($(this).text());
              $('.search-type-dropdown').data('value', $(this).data('value'));
            }
          });
        }

        // Preselect the catalogCategory dropdown
        if (catalogCategory && $('.dropdown-catalog').length) {
          $('.dropdown-catalog .options li').each(function() {
            if ($(this).data('value') === catalogCategory) {
              // Set the selected option text and the data-value
              $('.dropdown-catalog .selected-option').text($(this).text());
              $('.dropdown-catalog').data('value', $(this).data('value'));
            }
          });
        }

        // Preselect the eventBranch dropdown
        if (eventBranch && $('.dropdown-branches').length) {
          $('.dropdown-branches .options li').each(function() {
            if ($(this).data('value') === eventBranch) {
              // Set the selected option text and the data-value
              $('.dropdown-branches .selected-option').text($(this).text());
              $('.dropdown-branches').data('value', $(this).data('value'));
            }
          });
        }

      } else {
        // Fallback for normal select elements if the custom dropdowns are not visible
        if (searchType) {
          $('.search-type').val(searchType).change();
        }
    
        if (catalogCategory && $('.dropdown-catalog').length) {
          $('.dropdown-catalog').val(catalogCategory);
        }
    
        if (eventBranch && $('.dropdown-branches').length) {
          $('.dropdown-branches').val(eventBranch);
        }
      }
  }

  // Function to initialize custom dropdown functionality
  function initializeCustomDropdowns() {
    $('.custom-dropdown').each(function () {
      var $dropdown = $(this);
      var $selected = $dropdown.find('.selected-option');
      var $options = $dropdown.find('.options');

      // Toggle visibility of the options list
      $selected.on('click', function () {
        $options.toggle();
      });

      $('.custom-dropdown.dropdown-branches').css('display', 'none');

      // Handle selecting an option
      $options.on('click', 'li', function () {
        var $selectedOption = $(this); // Now `this` refers to the clicked `li`
        customDropdownsVisibility($dropdown, $selected, $selectedOption, $options);
      });

      // Run the visibility logic on page load for the dropdown
      var $initialSelectedOption = $options.find('li.selected'); // You can define a default selected option
      customDropdownsVisibility($dropdown, $selected, $initialSelectedOption, $options);
    });

    // Find the selected option in the custom dropdown
    var $dropdown = $('.custom-dropdown.search-type-dropdown:visible');
    var $selectedOption = $dropdown.find('.selected-option');
    var $optionToClick = $dropdown.find('.options li').filter(function() {
      return $(this).text() === $selectedOption.text();
    });

    // Trigger the click event on the selected option
    if ($optionToClick.length) {
      $optionToClick.trigger('click');
    }

    // Close dropdowns if the user clicks outside of them
    $(document).on('click', function (event) {
      if (!$(event.target).closest('.custom-dropdown').length) {
          $('.custom-dropdown .options').hide();
      }
    });
  }

  // Function to handle dropdown visibility and selection
  function customDropdownsVisibility($dropdown, $selected, $selectedOption, $options) {

    if ($('.header__search.mobile-only.active').length) { // If it's the mobile search, don't show any custom dropdown
      $('.custom-dropdown').css('display', 'none');
      return;
    }

    // Ensure $selectedOption is defined before accessing its text or data
    if ($selectedOption && $selectedOption.length) {
      // Replace the text instead of concatenating it
      $selected.text($selectedOption.text());
      $dropdown.data('value', $selectedOption.data('value'));
    }

    $options.hide();

    // Logic based on selected value
    if ($selectedOption && $selectedOption.data('value') === 'search-catalog') {
      $('.header__search .search-field').attr('name', 'term');
      $('.custom-dropdown.dropdown-branches').css('display', 'none');
      $('.custom-dropdown.dropdown-catalog').css('display', 'flex');
    } else if ($selectedOption && ($selectedOption.data('value') === 'search-site' || $selectedOption.data('value') === 'search-events')) {

      if ($selectedOption.data('value') === 'search-site') {
        $('.custom-dropdown.dropdown-catalog').css('display', 'none');
        $('.custom-dropdown.dropdown-branches').css('display', 'none');
        $('.search-bar__filters').addClass('search-site'); // Adding this class to control the visibility of the field

        $('.custom-dropdown.search-type-dropdown').css('width', '280px'); // Adding this width to avoid display issues

        $('.header__search .search-field').attr('name', 's');

      } else {
        $('.custom-dropdown.dropdown-branches').css('display', 'flex');
        $('.custom-dropdown.dropdown-catalog').css('display', 'none');
        $('.header__search .search-field').attr('name', 's');
      }

      $('.header__search form').attr('target', '_self');

    } else if ($selectedOption && $selectedOption.data('value') === 'advanced-search') {
      window.open('https://polaris.hclibrary.org/polaris/search/default.aspx?ctx=1.1033.0.0.3&type=Advanced', '_blank');
    }
  }

})(jQuery);
